import { Component, Vue, Watch } from 'vue-property-decorator';

import { UserMgr } from '@/api/index';
import { Regexp } from '@/utils/validate';

@Component
export default class UserList extends Vue {
  private searchValue: string = ''; // 搜索框Value
  private userTableData: object[] = []; // 用户表格数据
  private dialogFormVisible = false; // 新建/编辑用户模态框是否展示
  // 分页
  private page: any = {
    currPage: 1,
    size: 10,
    total: 0,
    sizes: [10, 20, 50, 100],
    layout: 'total, sizes, prev, pager, next, jumper'
  };
  private statusIconDict: any = {
    ['锁定']: 'icon-state-disabled',
    ['有效']: 'icon-state-enabled'
  };
  // 表格表头设置
  private columns: object[] = [
    { prop: 'userName', title: '用户名' },
    { prop: 'sex', title: '性别' },
    { prop: 'mobile', title: '联系电话' },
    { prop: 'email', title: '邮箱' },
    { prop: 'status', title: '状态', type: 'status' },
    { prop: 'description',  title: '描述', showTooltip: true},
    { prop: 'createTime',  title: '注册时间', filter: 'time'}
  ];
  // 初始化
  private created() {
    this.getUserTableData();
  }
  // 搜索按钮Click
  private searchBtnClick() {
    this.getUserTableData();
  }
  // 获取用户表格数据
  private getUserTableData(currPage = 1) {
    this.page.currPage = currPage;
    UserMgr.getUserList(this.searchValue, this.page.currPage, this.page.size).then((res: any) => {
      this.userTableData = res.data;
      this.page.total = parseInt(res.headers.total, 10);
    });
  }
  // 表格分页条数Change
  private pagesizeChange(value) {
    this.page.size = value;
    this.getUserTableData();
  }
  // 表格当前页Change
  private currentPageChange(value) {
    this.getUserTableData(value);
  }
  // 新建用户
  private addUser() {
    this.dialogFormVisible = true;
    this.optUserKey = 'add';
    this.loadOptUserForm(null);
  }
  // 编辑用户
  private editUser(user) {
    this.dialogFormVisible = true;
    this.optUserKey = 'edit';
    this.loadOptUserForm(user.userId);
  }
  // 删除用户
  private deleteUser(user) {
    this.$confirm('确定删除该用户？', '删除用户', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      UserMgr.deleteUser(user.userId).then(() => {
        this.getUserTableData();
      });
    });
  }

  /********** 新建/编辑用户模态框相关 **********/
  private optUserKey = ''; // 新建/编辑用户的KEY
  private roleOptions: object[] = []; // 角色下拉框Option
  private invalid: boolean = true; // 保存按钮是否可点
  // 新建/编辑FORM
  private optUserForm: any = {
    userName: '',
    mobile: '',
    email: '',
    description: '',
    roleList: [],
    status: '',
    sex: ''
  };
  // 字典表
  private dicts: any = {
    status: [],
    usr_sex: []
  };
  // 加载新建、编辑用户Form
  private loadOptUserForm(userId) {
    this.clearUserForm();
    if (this.optUserKey === 'edit') {
      this.getUserById(userId);
    }
    this.getRoleOptions();
    this.getDicts();
  }
  // 获取用户详情通过Id
  private getUserById(userId) {
    UserMgr.getUserById(userId).then(user => {
      this.optUserForm.userId = user.data.userId;
      this.optUserForm.userName = user.data.userName;
      this.optUserForm.mobile = user.data.mobile;
      this.optUserForm.email = user.data.email;
      this.optUserForm.sex = user.data.sex;
      this.optUserForm.status = user.data.status;
      this.optUserForm.description = user.data.description;
      this.optUserForm.roleList = user.data.roleList.map(item => item.roleId);
    });
  }
  // 获取字典表
  private getDicts() {
    const array = ['usr_sex', 'usr_status'];
    for (const item of array) {
      UserMgr.getDicts(item).then(res => {
        this.$set(this.dicts, item, res.data);
        if (this.optUserKey === 'add') {
          if (item === 'usr_sex') {
            this.optUserForm.sex = this.dicts[item][0].value;
          } else if (item === 'usr_status') {
            this.optUserForm.status = this.dicts[item][0].value;
          }
        }
      });
    }
  }
  // 获取角色下拉框Options
  private getRoleOptions() {
    UserMgr.getRoleList('', '', '').then(res => {
      this.roleOptions = res.data;
    });
  }
  // 表单验证规则
  get userRules(): object {
    return {
      userName: this.optUserKey === 'edit' ? [] : [Regexp().required, Regexp().maxLength(50), Regexp().minLength(2)],
      roleList: [ Regexp().required ],
      mobile: [ Regexp().phone ],
      email: [ Regexp().email ]
    };
  }
  // 实时验证表单 判断确定按钮是否可用
  private validateForm() {
    this.invalid = (this.$refs.optUserForm as any).fields.some((e: any) =>
      e.isRequired ? e.validateState !== 'success' : e.validateState === 'error'
    );
  }
  // 保存用户
  private saveUser() {
    const roles: object[] = [];
    for (const each of this.optUserForm.roleList) {
      roles.push({ roleId: each });
    }
    const param: object = {
      userId: this.optUserForm.userId,
      userName: this.optUserForm.userName,
      mobile: this.optUserForm.mobile,
      email: this.optUserForm.email,
      roleList: roles,
      status: this.optUserForm.status,
      sex: this.optUserForm.sex,
      description: this.optUserForm.description
    };
    if (this.optUserKey === 'add') {
      UserMgr.addUser(param).then(res => {
        this.dialogFormVisible = false;
        this.optUserKey = '';
        this.getUserTableData();
        this.clearUserForm();
      });
    } else {
      UserMgr.editUser(param).then(res => {
        this.dialogFormVisible = false;
        this.optUserKey = '';
        this.getUserTableData();
        this.clearUserForm();
      });
    }
  }
  // 取消新建/编辑按钮
  private cancleDialog() {
    this.dialogFormVisible = false;
    this.optUserKey = '';
    this.clearUserForm();
  }
  // 清空Form数据
  private clearUserForm() {
    this.optUserForm.userId = '';
    this.optUserForm.userName = '';
    this.optUserForm.mobile = '';
    this.optUserForm.email = '';
    this.optUserForm.description = '';
    this.optUserForm.roleList = [];
    this.invalid = true;
    setTimeout(() => {
      (this.$refs.optUserForm as any)?.clearValidate();
    }, 300);
  }
}
